<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
    }
  },
  computed: {
  }
}
</script>

<style>
  *{
    margin:0;
    padding:0
  }
  html,body{
    height:100%;
  }
  #app {
    font-family: PingFangSC-light,"Source Sans Pro","Helvetica Neue",Arial,"Hiragino Sans GB","Microsoft YaHei","WenQuanYi Micro Hei",sans-serif;
    text-align: -webkit-center;
    color: #101010;
    height:100%;
  }
  @media only screen and (min-width: 1080px) {
    .dialog{
      width:30%
    }
    .dialog .el-button{
      background: #e83439;color:#fff;
      width:100px;heihgt:30px
    }
    .dialog .el-dialog__body{
      padding:10px 40px !important;
    }
  }
  @media only screen and (max-width: 1080px) {
    .dialog{
      width:90%;
      margin-top:0 !important;
    }
    .dialog .el-button{
      background: #e83439;color:#fff;
      width:100px;heihgt:30px
    }
    .dialog .el-dialog__body{
      padding:10px 20px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue